export default {
      id: "court-house-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#court-house",
      toString: function () {
        return this.url;
      }
    }